import type { FirebaseOptions } from "firebase/app"
import type { EyeconsUrls } from 'eyecons-requests'

// !!! Careful, only expose public variables !!!
export type RuntimeConfig = {
    eyecons: {
        adsEnabled: boolean
        env: string
        urls: EyeconsUrls,
    },
    firebase: FirebaseOptions,
    ga: {
        tagId: string
    },
    jwPlayer: {
        playerId: string,
    },
}

export const runtimeConfig: RuntimeConfig = {
    eyecons: {
        adsEnabled: process.env.ADS === 'true',
        env: process.env.SITE_ENV! ?? '',
        urls: {
            auth: process.env.AUTH_URL! ?? '',
            backend: process.env.BACKEND_URL! ?? '',
            cdn: process.env.CDN_URL! ?? '',
            dashboard: process.env.DASHBOARD_URL! ?? '',
            ecommerce: process.env.ECOMMERCE_URL! ?? '',
            media: process.env.MEDIA_URL! ?? '',
            site: process.env.SITE_URL! ?? '',
        },
    },
    firebase: {
        projectId: process.env.FIREBASE_PROJECT_ID! ?? '',
        appId: process.env.FIREBASE_APP_ID! ?? '',
        databaseURL: process.env.FIREBASE_DATABASE_URL! ?? '',
        storageBucket: process.env.FIREBASE_STORAGE_BUCKET! ?? '',
        apiKey: process.env.FIREBASE_API_KEY! ?? '',
        authDomain: process.env.FIREBASE_AUTH_DOMAIN! ?? '',
        messagingSenderId: process.env.FIREBASE_MESSAGE_SENDER_ID! ?? '',
        // measurementId: process.env.FIREBASE_MEASUREMENT_ID!,
        // debugToken: process.env.FIREBASE_DEBUG_TOKEN!,
        // vapIdKey: process.env.FIREBASE_VAP_ID_KEY!,
    },
    ga: {
        tagId: process.env.GOOGLE_ANALYTICS! ?? '',
    },
    jwPlayer: {
        playerId: process.env.JW_PLAYER_ID! ?? '',
    },
}